export const acciones = [
    {
        "anio" : "¿Conoces la UIIMH?",
        "descripcion" : "Su proposito es eliminar cualquier forma de descriminacion basada en el género",
        "trimestres" : [
            {
                "trimestre" : ".",
                "url" : "../Uiimh"
            }
        ]
    }
]